module.exports = __webpack_public_path__ + "img/latamhair.f82aca1a.png";